<template>
  <div class="widget widget-checkbox" :data-field="fieldName" :id="fieldName">
    <input type="checkbox" :checked="value" :class="[autoWidth ? 'auto-width' : '', readOnly ? 'readOnly' : '']" v-on:change="onChange" :disabled="!editable">
  </div>
</template>

<script>
export default {
  name: 'checkbox-widget',

  props: {
    fieldIndex: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      value: ''
    }
  },

  mounted () {
    this.value = this.initialValue === 'true'

    let that = this
    this.$on('setValue', function (val) {
      that.value = val === 'true'
    })
  },

  methods: {
    onChange (e) {
      this.value = e.target.checked
      this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: this.value.toString()})
    }
  },

  beforeDestroy () {
    this.$off('setValue')
  }
}
</script>

<style lang="scss" scoped>
  .readOnly {
    pointer-events: none;
  }

  input[type=checkbox] {
    display: block;
    z-index: 1;
  }

  .auto-width {
    margin: 0 auto;
    display: table;
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/widgets/CheckboxWidget.vue